goog.provide("shadow.js.shim.module$$js_joda$core");
goog.provide("module$shadow_js_shim_module$$js_joda$core");
shadow.js.shim.module$$js_joda$core = shadow.js.nativeProvides["@js-joda/core"] = shadow$bridge("@js-joda/core");
module$shadow_js_shim_module$$js_joda$core.default = shadow.js.shim.module$$js_joda$core;
